import { attempt } from '@shared/utils'
import { logger } from '@shared/lib/logger'
import type { Order, OrderListResponse } from '../types/order.types'

export const fetchOrders = async (api: string, authorizationHeader: string, tenantId: string): Promise<Order[]> => {
  const url = new URL(`${api}/api/v1/external/orders`)
  url.searchParams.set('pageSize', '2')
  url.searchParams.set('pageNumber', '0')
  if (tenantId) {
    url.searchParams.set('tenantId', tenantId)
  }

  const { data: response, error: fetchError } = await attempt(
    fetch(url.toString(), {
      method: 'GET',
      headers: {
        Authorization: authorizationHeader,
      },
    }),
  )

  if (fetchError) {
    logger.error('Error fetching orders', {
      action: 'fetch_orders_error',
      errorMessage: JSON.stringify(fetchError),
    })
    return []
  }

  if (!response.ok) {
    logger.error('Error fetching orders', {
      action: 'fetch_orders_error',
      status: response.status,
      statusText: response.statusText,
    })
    return []
  }

  const { data: json, error: parseError } = await attempt(response.json() as Promise<Order[] | OrderListResponse>)

  if (parseError) {
    logger.error('Error fetching orders', {
      action: 'fetch_orders_parse_error',
      errorMessage: String(parseError),
    })
    return []
  }

  return Array.isArray(json) ? json : (json.data ?? [])
}
